import noImage from '../assets/image/app/no-image.png';

export const fileRender = (url) => {
    const prefix = `${process.env.REACT_APP_DOMAIN}/api/v1/media`;
    if (url) return `${prefix}${url.replaceAll(prefix, '')}`;
};
export const photoRender = (url) => url ? `${process.env.REACT_APP_DOMAIN}/api/v1/media${url}` : noImage;